import Controller from "./stepper.controller";
import template from "./stepper.html";

const stepper = {
  template,
  controller: Controller,
  bindings: {
    stepperModel: "=",
    steps: "<",
    confirm: "<",
    events: "<",
  },
};

export default stepper;



// WEBPACK FOOTER //
// ./src/components/stepper/stepper.component.js